<template>
    <div class="method-dropdown"
         v-click-outside="setDisabled">
        <div class="method-dropdown__select-area"
             @click="selectToggle">
            <!--<h3 class="method-dropdown__title">-->
                <!--{{ 'Which session you want to book?' | translate }}-->
            <!--</h3>-->
            <div v-if="getLabel(selectedMethod)"
                 :title="getLabel(selectedMethod)"
                 class="flex between-xs">
                <span class="method-dropdown__name">
                    {{ getLabel(selectedMethod) }}
                </span>
                <!-- <span class="method-dropdown__duration mobile-hide"> -->
                <span class="method-dropdown__duration">
                    {{ getDuration(selectedMethod) }} Min
                </span>
                <span v-if="getPrice(selectedMethod) > 0" class="method-dropdown__price">
                    {{ getPrice(selectedMethod) }} {{ currency }}
                </span>
            </div>
            <span v-else
                  class="method-dropdown__placeholder">
                {{ placeholder }}
            </span>
            <div class="method-dropdown__icon-holder">
                <icon :name="getArrowName"
                      :width="28"
                      color="dark-blue"></icon>
            </div>
        </div>

        <div class="method-dropdown__list-holder"
             v-if="isOpen && !isEmptyMethodList">
            <ul class="method-dropdown__list-items">
                <li class="method-dropdown__list-item "
                    v-for="(method, index) in methods" :key="index"
                    :class="{ 'method-dropdown__list-item--grey': index % 2}"
                    :title="getLabel(method)"
                    @click="setMethod(method)">
                    <div v-if="getLabel(method)"
                         class="flex between-xs">
                        <span class="method-dropdown__name">
                            {{ getLabel(method) }}
                        </span>
                        <!-- <span class="method-dropdown__duration mobile-hide"> -->
                        <span class="method-dropdown__duration">
                            {{ getDuration(method) }} Min
                        </span>
                        <span v-if="getPrice(method) !== ''" class="method-dropdown__price">
                            {{ getPrice(method) }} {{ currency }}
                        </span>
                    </div>
                    <span v-else
                          class="method-dropdown__placeholder">
                        -
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import ClickOutside from '../../directives/ClickOutside'
    import Icon from '../icon/Icon'

    export default {
        name: 'method-dropdown',
        components: {
            Icon
        },
        props: {
            placeholder: {
                type: String,
                default: 'Zeige alles'
            },
            currency: {
                type: String,
                default: 'CHF'
            },
            methods: {
                type: Array,
                default() {
                    return [];
                }
            },
            selected: {
                type: Object,
                default() {
                    return {};
                }
            }
        },
        data() {
            return {
                selectedMethod: this.selected || {},
                isOpen: false
            };
        },
        watch: {
            selected(newValue) {
                this.selectedMethod = newValue || {};
            }
        },
        computed: {
            isEmptyMethodList () {
                return this.methods.length === 0;
            },
            getArrowName () {
                return this.isOpen ? 'arrow-up' : 'arrow-down';
            }
        },
        methods: {
            getLabel(method) {
                return method['name'] || '';
            },
            getDuration(method) {
                return method['duration'] || '';
            },
            getPrice(method) {
                return method['price'] || '';
            },
            setMethod(method) {
                this.selectedMethod = method;

                this.$emit('select', method);

                this.setDisabled();
            },
            setActive() {
                this.isOpen = true;
            },
            setDisabled() {
                this.isOpen = false;
            },
            selectToggle() {
                this.isOpen = !this.isOpen;
            }
        },
        directives: {
            ClickOutside
        }
    }
</script>

<style lang="less">
  @import "../../less/variables.less";

  .method-dropdown {
      position: relative;
      z-index: 15;
      background: white;
      border: 1px solid @light-grey;
      min-height: 44px;

      &__title {
          font-size: 0.875rem;
          line-height: 1.25rem;
          color: @black-grey;
          margin: 0 0 5px;
          text-align: left;
      }

      &__icon-holder {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          width: 34px;
          display: flex;
          justify-content: center;
          align-items: center;
      }

      &__select-area {
          position: relative;
          z-index: 10;
          border: 0;
          padding: 11px 40px 11px 13px;
          font-size: 0.875rem;
          line-height: 1.25rem;
          font-weight: 700;
          color: @dark-blue;
          background-color: transparent;
          box-sizing: border-box;
          cursor: pointer;

          &:focus {
              outline: none;
          }
      }

      &__name {
          min-width: 40%;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
      }

      &__duration {
          min-width: 24%;
          padding: 0 10px 0 5px;
          text-align: right;
          white-space: nowrap;
      }

      &__price {
          min-width: 26%;
          text-align: right;
          white-space: nowrap;
      }

      &__placeholder {
         font-size: 0.9375rem;
         color: @grey80;
      }

      &__list-holder {
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
          margin: 1px -1px 0 -1px;
          background: white;
          border: 1px solid @light-grey;
          border-top: 0;
          z-index: 10;
      }

      &__list-items {
          padding: 0;
          margin: 0;
          list-style: none;
          font-size: 0.875rem;
          line-height: 1.25rem;
          font-weight: 600;
          color: @black-grey;
      }

      &__list-item {
          padding: 9px 40px 9px 11px;
          cursor: pointer;

          &--grey {
              background: @light-green-2;
          }

          &:hover,
          &:active {
              background: @secondary;
              color: white;
          }
      }

      @media @viewport-md {
          &__title {
              font-size: 0.75rem;
              line-height: 1.25rem;
          }

          &__select-area {
              font-size: 0.75rem;
              line-height: 1.125rem;
          }

          &__list-items {
              font-size: 0.75rem;
              line-height: 1.125rem;
          }
      }

      @media @viewport-xs {
          min-height: 44px;

          &__icon-holder {
              width: 28px;
          }

          &__title {
              font-size: 0.75rem;
              line-height: 1.25rem;
          }

          &__select-area {
              padding: 12px 30px 12px 7px;
              font-size: 0.75rem;
              line-height: 1.125rem;
          }

          &__list-items {
              font-size: 0.75rem;
              line-height: 1.125rem;
          }

          &__list-item {
              padding: 12px 30px 12px 7px;
          }

          &__price {
              padding-left: 10px;
              min-width: 35%;
          }
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/method-dropdown/MethodDropdown.vue